<template>
    <div class="tieba-rank-wrapper">
        <div class="left" @click="goRank('rankClick')">
            <img
                :src="rankEntryInfo.rank_icon"
                class="left-icon"
            >
            <div class="middle-info">
                <span class="top">{{ rankEntryInfo.rank_name }}</span>
                <span class="bottom">
                    <span
                        class="desc"
                        :class="{'max-desc': !rankEntryInfo.has_rank}"
                    >
                        {{ rankEntryInfo.rank_desc }}
                    </span>
                    <span
                        v-if="rankEntryInfo.has_rank"
                        class="num"
                    >
                        No.{{ rankEntryInfo.rank_num }}
                    </span>
                    <i class="right-icon"></i>
                </span>
            </div>
        </div>
        <div class="right" @click="handleRightBtn">
            <span class="text">{{ rankEntryInfo.btn_text }}</span>
            <img src="https://fenwan.cdn.bcebos.com/cms/gamenow/webgame/2023-2/1675668674954/3a807ec19220.gif" class="ani">
            <i class="right-icon"></i>
        </div>
    </div>
</template>

<script>
import tbNAPI from '@baidu/tb-napi';
import {generateToken} from '@/utils/tiebaUtility';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {getQueryString, getUrlParams} from '@/utils/url';
import api from '@/api';

export default {
    props: {
        rankEntryInfo: {
            type: Object,
            default: () => {},
        },
        gameInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isTiebaApp: false,
        };
    },
    mounted() {
        this.urlParams = getUrlParams();
        this.isTiebaApp = tbNAPI.env.isTBAPP;
        this.showLog();
    },
    methods: {
        showLog() {
            const {app_name, app_type} = this.gameInfo;
            const {tab_id, tag_id, has_rank} = this.rankEntryInfo;
            const {srcid, sid, zoneAppId, channelid} = this.urlParams;
            this.$logger.display({
                value: 'entranceDisplay',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: {
                                gameName: app_name,
                                gameId: zoneAppId,
                                gameType: app_type,
                                primaryTab: tab_id,
                                secondaryTab: tag_id,
                                module: has_rank ? 'rankedEntrance' : 'nonRankedEntrance',
                                sid: sid || '',
                                srcId: srcid || '',
                                channelid: channelid || '',
                            },
                            pos: '',
                        },
                    ],
                },
            });
        },
        report(token) {
            const {device, os} = window.tbLibPlugin.parse();
            const params = {
                data: {
                    cuid: '',
                    channelid: getQueryString('channelid') || '',
                    token,
                    device,
                    os,
                },
            };
            return api.newdetail.reportTbParams(params);
        },
        clickLog(type) {
            const {app_name, app_type} = this.gameInfo;
            const {tab_id, tag_id, has_rank} = this.rankEntryInfo;
            const {srcid, sid, zoneAppId, channelid} = this.urlParams;
            this.$logger.click({
                value: type,
                ext: {
                    id: '',
                    ext: {
                        gameName: app_name,
                        srcId: srcid || '',
                        sid: sid || '',
                        gameId: zoneAppId,
                        channelid: channelid || '',
                        gameType: app_type,
                        module: has_rank ? 'rankedEntrance' : 'nonRankedEntrance',
                        primaryTab: tab_id,
                        secondaryTab: tag_id,
                    },
                    pos: '',
                },
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        // 前往榜单页面
        goRank(type) {
            this.clickLog(type);
            setTimeout(() => {
                window.location.href = this.rankEntryInfo.rank_url;
            }, 100);
        },
        // 获取token
        getToken(url) {
            const config = {
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    track: 'test',
                    url,
                },
            };
            return generateToken(config);
        },
        // 调起贴吧App
        wakeUpTiebaApp(token, pageUrl, pkgUrl) {
            TiebaNewWakeUp.init({
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    token: token,
                    url: encodeURIComponent(pageUrl),
                },
                androidDownUrl: pkgUrl,
                androidShoubaiGoCenterPage: false,
                middlePageBrowsers: [],
            });
        },
        // 右侧按钮点击
        handleRightBtn() {
            if (this.isTiebaApp) {
                this.goRank('lotteryBtnClick');
                return;
            }

            const {rank_url, btn_action, tieba_download_url} = this.rankEntryInfo;
            const token = this.getToken(rank_url);
            this.clickLog('lotteryBtnClick');
            this.report(token).then(() => {
                if (+btn_action === 2) { // 调起贴吧
                    this.wakeUpTiebaApp(token, rank_url, tieba_download_url);
                }
                else { // 进入下载中间页
                    window.location.href = 'https://tieba.baidu.com/mo/q/wise-grow-operate/downloadMidPage?bgImg=newdefault&wakeupConf=38&autoClick=0&isDown=0&isAppstore=0&downInfo=38&source=38';
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.tieba-rank-wrapper{
    width: 1140px;
    height: 177px;
    display: flex;
    box-sizing: border-box;
    padding: 36px;
    background-color: #F8F8F8;
    border-radius: 27px;
    margin: 45px auto 21px;
    align-items: center;
    justify-content: space-between;

    .left {
        display: flex;
        align-items: center;
    }

    .left-icon {
        width: 105px;
        height: 105px;
        object-fit: cover;
    }

    .middle-info {
        margin-left: 24px;
        display: flex;
        flex-direction: column;

        .top {
            font-family: PingFangSC-Medium;
            font-size: 45px;
            color: #1F1F1F;
            line-height: 45px;
            font-weight: 500;
            max-width: 500px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: left;
        }

        .bottom {
            display: flex;
            font-size: 36px;
            color: #8F8E94;
            line-height: 40px;
            margin-top: 22px;
            height: 36px;
            align-items: center;

            .desc {
                max-width: 360px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .max-desc {
                max-width: 500px;
            }

            .num {
                color: #3388FF;
                margin-left: 9px;

            }
        }
    }

    .right-icon {
        width: 30px;
        height: 30px;
        background: url('~public/assets/imgs/ic-tieba-rank-entry.png') center center/100% auto no-repeat;
    }

    .right {
        flex-shrink: 0;
        display: flex;
        align-items: center;

        .text {
            font-size: 36px;
            color: #8F8E94;
            max-width: 200px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .ani {
            width: 90px;
            height: 90px;
            margin-left: 6px;
        }
    }
}
</style>
